import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/memberships/?role=TEACHER|STUDENT
// → [{ id, user: { id, email, full_name }, role, ... }]
function useMemberships(role) {
  return useQuery({
    queryKey: ["memberships", role],
    queryFn: () =>
      apiClient
        .get("/api/v1/memberships/", { params: { role } })
        .then((r) => r.data),
    enabled: !!role,
  });
}

export { useMemberships };
